import React, { useRef } from "react";
import "quill/dist/quill.snow.css";
import { Button } from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";

const RichTextEditor = ({ formData, setFormData }) => {
  const editorRef = useRef(null);

  const logContent = () => {
    if (editorRef.current) {
      console.log(editorRef.current.getContent());
    }
  };

  return (
    <div>
      <Editor
        apiKey="igxar9mhz20dy1vlfjflepeu0zy3zuscbt3toetcoua5b1kg"
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue="<p>Start creating something amazing...</p>"
        value={formData.content}
        onEditorChange={(content) => {
          setFormData({ ...formData, content });
        }}
        init={{
          height: 500,
          menubar: true,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount",
            "lists",
          ],
          toolbar:
            "undo redo | formatselect | bold italic backcolor | " +
            "            alignleft aligncenter alignright alignjustify | " +
            "            bullist numlist outdent indent | removeformat | help",
        }}
      />

      <Button onClick={logContent}>Log Content</Button>
    </div>
  );
};

export default RichTextEditor;
